import { render } from "./TopbarLogin.vue?vue&type=template&id=128a5b59"
import script from "./TopbarLogin.vue?vue&type=script&lang=js"
export * from "./TopbarLogin.vue?vue&type=script&lang=js"
script.render = render

export default script